import { render, staticRenderFns } from "./FormulaCapture.vue?vue&type=template&id=10d8b1ba&scoped=true"
import script from "./FormulaCapture.vue?vue&type=script&lang=js"
export * from "./FormulaCapture.vue?vue&type=script&lang=js"
import style0 from "./FormulaCapture.vue?vue&type=style&index=0&id=10d8b1ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d8b1ba",
  null
  
)

export default component.exports